import { storageKeys } from "../constants/storageKeys";
import { DatabasePageSizeMeta } from "../Types";

const pageSizeMap: Array<keyof DatabasePageSizeMeta, string> = [
  ["customerDefaultPageSize", storageKeys.CUSTOMER_DB_PAGESIZE],
  ["jobDefaultPageSize", storageKeys.JOB_DB_PAGESIZE],
  ["quarryDefaultPageSize", storageKeys.QUARRY_DB_PAGESIZE],
  ["uploadDefaultPageSize", storageKeys.TICKET_UPLOAD_PAGESIZE],
  ["processingDefaultPageSize", storageKeys.TICKET_PROCESSING_PAGESIZE],
  ["invoiceListDefaultPageSize", storageKeys.INVOICE_LIST_PAGESIZE],
  ["invoiceTileDefaultPageSize", storageKeys.INVOICE_TILE_PAGESIZE],
  ["lienDefaultPageSize", storageKeys.LIEN_PAGESIZE],
  ["truckingAndMaterialDefaultPageSize", storageKeys.CRM_PAGESIZE],
];

const restoreSizeMap: Array<string, string> = [
  ["customerRestorePageSize", storageKeys.RESTORE_CUSTOMER_PAGESIZE],
  [
    "customerDependentRestorePageSize",
    storageKeys.RESTORE_CUSTOMER_DEP_PAGESIZE,
  ],
  ["jobRestorePageSize", storageKeys.RESTORE_JOB_PAGESIZE],
  ["jobDependentRestorePageSize", storageKeys.RESTORE_JOB_DEP_PAGESIZE],
  ["ownerOperatorRestorePageSize", storageKeys.RESTORE_OWNER_PAGESIZE],
  [
    "ownerOperatorDependentRestorePageSize",
    storageKeys.RESTORE_OWNER_DEP_PAGESIZE,
  ],
  ["cdlRestorePageSize", storageKeys.RESTORE_CDL_PAGESIZE],
  ["quarryRestorePageSize", storageKeys.RESTORE_QUARRY_PAGESIZE],
  ["quarryDependentRestorePageSize", storageKeys.RESTORE_QUARRY_DEP_PAGESIZE],
];

export const updateSessionDatabasePagination = (data: DatabasePageSizeMeta) => {
  pageSizeMap.forEach(([dataKey, storageKey]) => {
    sessionStorage.setItem(storageKey, Number(data?.[dataKey] ?? 10));
  });

  restoreSizeMap.forEach(([dataKey, storageKey]) => {
    sessionStorage.setItem(storageKey, Number(data?.restore?.[dataKey] ?? 10));
  });
};
